<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header
          v-if="!everythingLoaded"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon class="load-rotate">hourglass_empty</md-icon>
          </div>
          <h4 class="title">Laden</h4>
        </md-card-header>
        <md-card-header
          v-if="everythingLoaded"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon>schedule</md-icon>
          </div>
          <h4 class="title">Overzicht van beschikbaarheid per chauffeur</h4>
        </md-card-header>
        <md-card-content>
          <template v-if="everythingLoaded">
            <md-checkbox
              v-for="(route, routeIndex) in routes"
              :value="routes[routeIndex].id"
              v-model="routesSelected"
              :key="'selectedRoute' + route.id"
              >{{ route["name"] }}</md-checkbox
            >
            <br />
          </template>
          <template v-if="everythingLoaded">
            <template v-for="years in availability.years">
              <md-checkbox
                v-for="(week, weekIndex) in years"
                :value="weekIndex"
                v-model="weeksSelected"
                :key="'selectedWeek' + week"
                >Week {{ weekIndex }}</md-checkbox
              >
            </template>
          </template>

          <table class="overview" v-if="everythingLoaded">
            <tr>
              <th>Naam</th>
              <th v-for="date in allDates()" :key="'head' + date">
                {{ formatDate(date) }} ({{ datesInWeeks[date] }})
              </th>
            </tr>
            <tr v-for="item in tableData" :key="'item' + item.id">
              <td>{{ getFullName(item) }}</td>
              <td v-for="date in allDates()" :key="date + item.id">
                <span
                  class="inline-badge"
                  v-for="availability in getAvailability(item.id, date)"
                  :key="
                    date + item.id + availability.routeId + availability.shiftId
                  "
                  :style="
                    'background-color: ' +
                      getAvailabilityColor(availability['availability'])
                  "
                >
                  {{
                    formatTime(
                      getAvailabilityLabel(
                        date,
                        availability["routeId"],
                        availability["shiftId"]
                      )
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <th>Totaal</th>
              <td v-for="date in allDates()" :key="'totals' + date">
                <span
                  class="inline-badge totals"
                  v-for="availability in getTotalAvailability(date)"
                  :key="
                    'totals' +
                      date +
                      availability.routeId +
                      availability.shiftId
                  "
                  style="background-color: #2196f3;"
                >
                  {{ availability.availability }}
                </span>
              </td>
            </tr>
          </table>
        </md-card-content>
        <md-card-actions v-if="everythingLoaded" md-alignment="space-between">
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    }
  },
  data() {
    return {
      currentSort: "sort",
      currentSortOrder: "asc",
      tableData: [],
      statuses: [],
      availability: [],
      routes: [],
      routesSelected: [],
      weeksSelected: [],
      datesInWeeks: {},
      drivers: [],
      totals: [],
      loaded: {
        drivers: false,
        availability: false,
        routes: false
      }
    };
  },
  methods: {
    loadDrivers() {
      this.loaded.drivers = false;
      this.$http.get(this.$apiBaseUrl + "drivers").then(
        response => {
          this.drivers = response.data.drivers;

          this.loaded.drivers = true;
          this.tableDataComputed();
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van roosters",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadRoutes() {
      this.loaded.routes = false;
      this.$http.get(this.$apiBaseUrl + "routes").then(
        response => {
          this.routes = response.data.routes;
          for (let i in this.routes) {
            this.routesSelected.push(this.routes[i].id);
          }

          this.loaded.routes = true;
          this.tableDataComputed();
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van routes",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadAvailability() {
      this.loaded.availability = false;
      this.$http
        .get(this.$apiBaseUrl + "schedules/report/drivers/availability")
        .then(
          response => {
            this.availability = response.data.availability;

            for (let year in this.availability.years) {
              for (let week in this.availability.years[year]) {
                this.weeksSelected.push(week);
                for (let dateIndex in this.availability.years[year][week]) {
                  this.datesInWeeks[
                    this.availability.years[year][week][dateIndex]
                  ] = week;
                }
              }
            }

            this.loaded.availability = true;
            this.tableDataComputed();
            this.calcTotals();
          },
          response => {
            if (response.status === 403) {
              this.notifyVue(
                "U heeft geen rechten voor het beheren van beschikbaarheid",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    getFullName(data) {
      return (
        data["firstName"] +
        " " +
        (data["lastNamePrefix"] ? data["lastNamePrefix"] + " " : "") +
        data["lastName"]
      );
    },
    getFullNameSort(data) {
      return (
        data["lastName"] +
        " " +
        (data["lastNamePrefix"] ? data["lastNamePrefix"] + " " : "") +
        data["firstName"]
      );
    },
    getAvailabilityColor(availability) {
      if (availability === 1) {
        return "#4caf50";
      }
      if (availability === 2) {
        return "#388e3c";
      }
      if (availability === 3) {
        return "#1b5e20";
      }

      return "#f44336";
    },
    getAvailabilityLabel(date, routeId, shiftId) {
      for (let shiftDate in this.availability["shifts"]) {
        if (date !== shiftDate) {
          continue;
        }
        for (let shiftIndex in this.availability["shifts"][shiftDate]) {
          if (
            this.availability["shifts"][shiftDate][shiftIndex]["route_id"] !==
              routeId ||
            this.availability["shifts"][shiftDate][shiftIndex]["shift_id"] !==
              shiftId
          ) {
            continue;
          }

          return this.availability["shifts"][shiftDate][shiftIndex][
            "beginTime"
          ];
        }
      }
      return "12:30";
    },
    allDates() {
      if (this.availability.shifts.length === 0) {
        return [];
      }

      let dates = [];
      for (let date in this.availability.shifts) {
        if (this.weeksSelected.indexOf(this.datesInWeeks[date]) === -1) {
          continue;
        }

        dates.push(date);
      }

      return dates;
    },
    tableDataComputed() {
      if (this.everythingLoaded === false) {
        return;
      }

      this.tableData = this.drivers;
      for (let i in this.tableData) {
        this.tableData[i]["sort"] = this.getFullNameSort(this.tableData[i]);
      }
      this.tableData = this.sortAll(this.tableData);

      return;
    },
    getAvailability(driverId, date) {
      let data = [];

      if (this.availability.drivers.hasOwnProperty(driverId) === false) {
        return data;
      }

      if (this.weeksSelected.indexOf(this.datesInWeeks[date]) === -1) {
        return data;
      }

      for (let routeId in this.availability.drivers[driverId][date]) {
        if (this.routesSelected.indexOf(routeId) === -1) {
          continue;
        }

        for (let shiftId in this.availability.drivers[driverId][date][
          routeId
        ]) {
          data.push({
            routeId: routeId,
            shiftId: shiftId,
            availability: this.availability.drivers[driverId][date][routeId][
              shiftId
            ]
          });
        }
      }

      return data;
    },
    getTotalAvailability(date) {
      let data = [];

      if (this.weeksSelected.indexOf(this.datesInWeeks[date]) === -1) {
        return data;
      }

      for (let driverId in this.availability.drivers) {
        for (let routeId in this.availability.drivers[driverId][date]) {
          if (this.routesSelected.indexOf(routeId) === -1) {
            continue;
          }

          for (let shiftId in this.availability.drivers[driverId][date][
            routeId
          ]) {
            let availability = "";
            for (let i in this.totals[date][routeId][shiftId]) {
              if (i == 9) {
                continue;
              }
              if (availability !== "") {
                availability += "/";
              }
              availability += this.totals[date][routeId][shiftId][i];
            }

            data.push({
              routeId: routeId,
              shiftId: shiftId,
              availability: availability
            });
          }
        }

        break;
      }

      return data;
    },
    calcTotals() {
      this.totals = {};
      for (let driverId in this.availability.drivers) {
        for (let date in this.availability.drivers[driverId]) {
          if (this.totals.hasOwnProperty(date) === false) {
            this.totals[date] = {};
          }
          for (let routeId in this.availability.drivers[driverId][date]) {
            if (this.totals[date].hasOwnProperty(routeId) === false) {
              this.totals[date][routeId] = {};
            }
            for (let shiftId in this.availability.drivers[driverId][date][
              routeId
            ]) {
              if (
                this.totals[date][routeId].hasOwnProperty(shiftId) === false
              ) {
                this.totals[date][routeId][shiftId] = {};
              }

              let availability = this.availability.drivers[driverId][date][
                routeId
              ][shiftId].toString();
              if (
                this.totals[date][routeId][shiftId].hasOwnProperty(
                  availability
                ) === false
              ) {
                this.totals[date][routeId][shiftId][availability] = 1;
              } else {
                this.totals[date][routeId][shiftId][availability]++;
              }
            }
          }
        }
      }
    },
    handleEditDriver(item) {
      //@todo fix
      this.$router.push("/schedules/edit/" + item.id);
    },
    formatDate(date) {
      if (typeof date !== "string" || date === "") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    formatTime: function(time) {
      return time.substr(0, 5);
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  created() {},
  mounted() {
    this.loadAvailability();
    this.loadDrivers();
    this.loadRoutes();
  }
};
</script>

<style lang="css" scoped>
table.overview {
  overflow-x: scroll;
  width: 100%;
  display: block;
}

table.overview tr th {
  white-space: nowrap;
  text-align: left;
}

table.overview tr td {
  white-space: nowrap;
}

table.overview tr th:first-child,
table.overview tr td:first-child {
  left: 8px;
  position: absolute;
  top: auto;
  width: 250px;
  background-color: #e0e0e0;
  z-index: 10;
  border: 1px solid #e0e0e0;
}

table.overview tr th:nth-child(2),
table.overview tr td:nth-child(2) {
  padding-left: 250px;
  position: relative;
}

table.overview tr:hover th,
table.overview tr:hover td {
  background-color: #aed581;
  border-color: #ffffff;
}

span.inline-badge {
  display: inline-block;
  border-radius: 12px;
  padding: 5px 8px;
  text-transform: uppercase;
  font-size: 10px;
  color: #ffffff;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  background-color: #4caf50;
}
span.inline-badge.totals {
  min-width: 41.5px;
}
</style>
